import React from "react";
import { Box, keyframes } from "@mui/material";
import logo from "../../assets/images/Logo.png";

// Continuous shimmer animation (left to right)
const shine = keyframes`
  0% {
    left: -30%;
  }
  100% {
    left: 130%;
  }
`;

const LogoLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 320,
          height: 70,
        }}
      >
        {/* Bottom Layer - Black & White Logo */}
        <img
          src={logo}
          alt="SwipeLounge Logo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: "grayscale(100%) brightness(0.7)", // black & white with slightly dimmed brightness
          }}
        />

        {/* Top Layer - Color Logo masked by the light sweep */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden", // clips the gradient area inside this box
            pointerEvents: "none",
          }}
        >
          <img
            src={logo}
            alt="SwipeLounge Logo Color"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "relative",
            }}
          />

          {/* Light sweep mask */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "30%",
              height: "100%",
              background:
                "linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.7) 50%, transparent 100%)",
              animation: `${shine} 2s linear infinite`,
              pointerEvents: "none",
              transform: "skewX(-20deg)",
              mixBlendMode: "screen", // blend to reveal color below
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LogoLoader;
